var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toggle-button',{attrs:{"value":_vm.switchValue,"width":55,"name":"switch","labels":{ checked: _vm.$t('global.yes'), unchecked: _vm.$t('global.no') },"disabled":_vm.isDisabled},on:{"change":_vm.onSwitchChange}})}
var staticRenderFns = []

export { render, staticRenderFns }